document.addEventListener("DOMContentLoaded", function() {
    var header = document.querySelector('.header');
          header.classList.remove('page-width');

    window.addEventListener('scroll', function() {
        if (window.scrollY > 0) {
            header.classList.add('my-scrolled');
        } else {
            header.classList.remove('my-scrolled');
        }
    });
});
